export const listYianOrders = (params: {
    'page'?: number,
    'pageSize'?: number
} = {}) => {
    let response = fetch(process.env.REACT_APP_ORDERS_API_URL + '/api/v1/yian/order?' + new URLSearchParams(params as any)).then(res => {
        return res.json()
    })
    return response
}